export default __webpack_public_path__ + "static/media/exit.c4bb40b5.svg";